import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import {environment} from "../../../environments/environment";

@Injectable()
export class UrlInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if(request.url.includes(environment.ApiAppUrl))
    {
      return next.handle(request);
    }

    if(request.url.includes('assets'))
    {
      return next.handle(request);
    }

    request = request.clone({url: `${environment.ApiAppUrl}${request.url}`});

    return next.handle(request);
  }
}
